import { Controller } from "@hotwired/stimulus";
import axios from "axios";

export default class extends Controller {
    static targets = [
        "articlesList",
        "typeUrl",
        "categorySelect",
        "searchBtn",
        "searchField",
        "csrf_token",
        "sortSelect",
        "all",
        "cases",
        "instructions",
        "features"
    ];

    static values = {
        sortBy: { type: String, default: "" },
        typeUrl: { type: String, default: "" }
    };

    connect() {
        const searchValue = new URLSearchParams(window.location.search).get('search');

        if (searchValue != null) {
            this.searchFieldTarget.value = searchValue;

            const url = new URL(window.location);
            url.searchParams.delete('search');
            window.history.replaceState({}, '', url);
        }
    }

    runFilter() {
        let locale = document.querySelector('[data-locale]').getAttribute('data-locale');
        const searchValue = this.searchFieldTarget.value.trim();

        // 🔁 Якщо пошук пустий — редірект на поточний URL
        if (searchValue === "") {
            window.location.href = window.location.href;
            return;
        }
        axios.defaults.headers.common["X-CSRF-TOKEN"] = this.csrf_tokenTarget.value;

        const pathSegments = window.location.pathname.split('/').filter(Boolean);
        const last = pathSegments.at(-1);

        const pageIdx = pathSegments.indexOf('page');
        const source =
          pageIdx !== -1 && pathSegments[pageIdx + 1] === 'tag'
            ? 'tag'
            : 'page';

        const data = {
            searchQuery: this.searchFieldTarget.value.trim(),
            locale: locale,
            source,
            ...(source === 'tag' && { tagUrl: last }),
        };

        if (this.sortByValue !== "") {
            data.sortBy = this.sortByValue;
        }

        axios
          .post("/page/articles/search-query", data)
          .then((response) => {
              this.articlesListTarget.innerHTML = response.data.data.content;

              if (response.data.articlesByView) {
                  this.searchFieldTarget.insertAdjacentHTML(
                    "afterend",
                    response.data.articlesByView.content
                  );
              }
          })
          .catch((error) => {
              console.error(error);
          });
    }

    onSearchBtnClick(event) {
        event.preventDefault();
        this.runFilter();
    }
}